import React from 'react';
import { Box } from '@mui/material';
import { LOG_TYPES } from '../../constants/logTypeRegistry';

const sizeMap = {
  sm: {
    log: { width: 6, height: 6 },
    incident: { width: 7, height: 7 },
    gap: 0.25,
  },
  md: {
    log: { width: 7, height: 7 },
    incident: { width: 8, height: 8 },
    gap: 0.3,
  },
};

const baseSharedMarkerSx = {
  border: '1px solid #FFFFFF',
  boxShadow: '0 1px 2px rgba(15, 23, 42, 0.18)',
  flexShrink: 0,
};

const TimelineDayStatusMarkers = ({
  hasLogs = false,
  hasIncident = false,
  selected = false,
  size = 'md',
  sx = {},
}) => {
  if (!hasLogs && !hasIncident) {
    return null;
  }

  const resolvedSize = sizeMap[size] || sizeMap.md;
  const markerColor = selected ? '#FFFFFF' : LOG_TYPES.activity.palette.dot;
  const incidentColor = selected ? '#FFFFFF' : LOG_TYPES.behavior.palette.dot;

  return (
    <Box
      aria-hidden="true"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: resolvedSize.gap,
        lineHeight: 0,
        ...sx,
      }}
    >
      {hasLogs ? (
        <Box
          sx={{
            ...baseSharedMarkerSx,
            width: resolvedSize.log.width,
            height: resolvedSize.log.height,
            borderRadius: '9999px',
            bgcolor: markerColor,
            boxShadow: selected ? '0 1px 2px rgba(15, 23, 42, 0.24)' : baseSharedMarkerSx.boxShadow,
          }}
        />
      ) : null}
      {hasIncident ? (
        <Box
          sx={{
            ...baseSharedMarkerSx,
            width: resolvedSize.incident.width,
            height: resolvedSize.incident.height,
            borderRadius: '2px',
            bgcolor: incidentColor,
            transform: 'rotate(45deg)',
            boxShadow: selected ? '0 1px 2px rgba(15, 23, 42, 0.24)' : baseSharedMarkerSx.boxShadow,
          }}
        />
      ) : null}
    </Box>
  );
};

export default TimelineDayStatusMarkers;
